<section class="sticky top-1 z-100 container mx-auto">
  <h2 class="sr-only" id="notificaciones">Notificaciones</h2>

  <div
    [class.fixed]="screenHandlerService.isModalPage()"
    aria-live="assertive"
    class="top-2xl mb-base px-base left-0 w-full">
    @for (notification of notices; track notification; let index = $index) {
      <desy-notification
        (isOpenChange)="onNotificationChange(index, $event)"
        [classes]="'mb-base c-notification--' + notification.type + ' top-2 container mx-auto bg-white'"
        [description]="notification.description"
        [isDismissible]="true"
        [items]="notification.items"
        [titleNotification]="{ text: notification.text, html: notification.html }"
        [type]="notification.type"
        id="notific-flotante">
      </desy-notification>
    }
  </div>
</section>
